import { upImage } from "@/api/common/api";
import identify1 from "@/assets/images/vita/identify_edit1.png";
import identify2 from "@/assets/images/vita/identify_edit2.png";
import placePhoto from "@/assets/images/vita/vita_stu_photo.png";
import tipsFront from "@/assets/images/vita/idcard_front.png";
import tipsEnd from "@/assets/images/vita/idcard_end.png";
import tipsPhoto from "@/assets/images/vita/tips_photo.png";
export default {
  data() {
    return {
      cardFront: identify1,
      cardBack: identify2,
      photo: placePhoto,
      tipsFront,
      tipsEnd,
      tipsPhoto,
      showTipsFront: true,
      showTipsEnd: true,
      showTipsPhoto: true,
    };
  },
  watch: {
    photo: {
      handler(val) {
        if(val === placePhoto) {
          this.$set(this.vitaForm, "profile_picture", "");
          this.showTipsPhoto = true;
        } else {
          this.$set(this.vitaForm, "profile_picture", val);
          this.showTipsPhoto = false;
        }
      },
    },
    cardFront: {
      handler(val) {
        if(val === identify1) {
          this.$set(this.vitaForm, "id_card_photo_front", "");
          this.showTipsFront = true;
        } else {
          this.$set(this.vitaForm, "id_card_photo_front", val);
          this.showTipsFront = false;
        }
      },
    },
    cardBack: {
      handler(val) {
        if(val === identify2) {
          this.$set(this.vitaForm, "id_card_photo_verso", "");
          this.showTipsEnd = true;
        } else {
          this.$set(this.vitaForm, "id_card_photo_verso", val);
          this.showTipsEnd = false;
        }
      },
    },
  },
  /*methods: {
    checkImg(file) {
      const reg = /^.*\.(jpg|jpeg|png|gif)$/i;
      const isJPG_PNG = reg.test(file.name);
      const isLt5M = file.size / 1024 / 1024 <= 5;

      if (!isLt5M) {
        this.$message({
          type: "error",
          message: "上传图片大小不能超过5MB!"
        });
      }
      if (!isJPG_PNG) {
        this.$message({
          type: "error",
          message: "仅支持jpg,jpeg,png,gif格式的图片"
        });
      }
      return isJPG_PNG && isLt5M;
    },
    // 头像
    photoImgChange(file) {
      const flag = this.checkImg(file);
      if (flag) {
        // 调用后台上传图片的接口
        let upParams = new FormData();
        upParams.append("image", file);
        upParams.append("filename", file.name);
        upImage(upParams)
          .then(({data}) => {
            // console.log(data);
            if(Number(data.status) === 0) {
              const imgUrl = window.URL.createObjectURL(file);
              this.photo = imgUrl;
              this.$set(this.vitaForm, "profile_picture", data.result.image_url);
            } else {
              this.$set(this.vitaForm, "profile_picture", "");
              this.photo = '';
            }
          })
          .catch((err)=>{
            console.error(err);
          });
      }
    },
    // 身份证
    cardFrontImgChange(file) {
      const flag = this.checkImg(file);
      if(flag) {
        let upParams = new FormData();
        upParams.append("image", file);
        upParams.append("filename", file.name);
        upImage(upParams)
          .then(({data}) => {
            // console.log(data);
            if(Number(data.status) === 0) {
              const imgUrl = window.URL.createObjectURL(file);
              this.cardFront = imgUrl;
              this.$set(this.vitaForm, "id_card_photo_front", data.result.image_url);
            } else {
              this.$set(this.vitaForm, "id_card_photo_front", "");
              this.cardFront = '';
            }
          })
          .catch((err)=>{
            console.error(err);
          });
      }
    },
    cardBackImgChange(file) {
      const flag = this.checkImg(file);
      if(flag) {
        let upParams = new FormData();
        upParams.append("image", file);
        upParams.append("filename", file.name);
        upImage(upParams)
          .then(({data}) => {
            // console.log(data);
            if(Number(data.status) === 0) {
              const imgUrl = window.URL.createObjectURL(file);
              this.cardBack = imgUrl;
              this.$set(this.vitaForm, "id_card_photo_verso", data.result.image_url);
            } else {
              this.$set(this.vitaForm, "id_card_photo_verso", "");
              this.cardBack = '';
            }
          })
          .catch((err)=>{
            console.error(err);
          });
      }
    },
  },*/
};